module.exports = __webpack_public_path__ + "assets/aa7a2fc4cea8b381b8abd0b1b841c5f2.svg";